export const handleOnKeyDown = <T extends HTMLElement>(event: React.KeyboardEvent<T>, nextField: string, customAction?: () => void) => {
  const enterKeyCode = 13
  const tabKeyCode = 9

  if ([enterKeyCode, tabKeyCode].includes(event.keyCode) && !event.shiftKey) {
    event.preventDefault()
    document.getElementById(nextField)?.focus()
    if (customAction !== undefined) {
      customAction()
    }
  }
}

export const handleOnKeyDownButton = <T extends HTMLElement>(event: React.KeyboardEvent<T>, nextField: string, customAction?: () => void) => {
  const enterKeyCode = 13

  if ([enterKeyCode].includes(event.keyCode) && !event.shiftKey) {
    event.preventDefault()
    document.getElementById(nextField)?.focus()
    if (customAction !== undefined) {
      customAction()
    }
  }
}
